import axios from "axios";
import toast from "react-hot-toast";

let isSessionExpired = false;

const axiosInstance = axios.create({
  baseURL: 'https://wip.fibrebondindustries.com',
  //baseURL: "https://localhost:5050",
  baseURLPath: "https://wip.fibrebondindustries.com/backend",
  withCredentials: true
});

// response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {

    if (error.response && error.response.status === 401 && !isSessionExpired) {

      isSessionExpired = true; // prevent multiple triggers

      try {
        // CALL LOGOUT API BEFORE CLEARING SESSION
        await axios.post(
          //"https://localhost:5050/api/logout",
          "https://wip.fibrebondindustries.com/api/logout",
          {},
          { withCredentials: true }
        );
      } catch (logoutError) {
        console.error("Logout API failed:", logoutError);
      }

      // cleanup local storage
      //localStorage.removeItem('deviceToken');
      localStorage.removeItem('user');
      localStorage.removeItem('loginTime');
      localStorage.removeItem('sessionExpiration');
      localStorage.removeItem('userData');

      //alert("Session expired. Please login again.");
      toast.error("Session expired. Please login again.");
      //window.location.href = "/";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;